import axios from "axios";
import { handleRequestError, memoizePromiseFn } from "../requests";


export const ParsePackagedProductBulk = async (file: File) => {
	if (!file) {
		throw new Error("ParsePackagedProductBulk requires a file");
	}

	const formData = new FormData();
	formData.append("file", file);

	const results = await axios.post(
		"/AssetManagement/ParsePackagedProductBulk",
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
			},
		},
	).catch(handleRequestError);

	return results.data;
};


//bulkInsertPackagedProduct
export const bulkInsertPackagedProduct = async (data) => {

	const results = await axios.post(
		"/AssetManagement/BulkInsertPackagedProduct",
		data,
	).catch(handleRequestError);

	return results.data;
};

const getDewarContainerSerialNumbers = async () => {
	const results = await axios.get(
		"/AssetManagement/DewarContainerSerialNumbers",
	).catch(handleRequestError);

	return results.data;
};

const getDewarProductTypeIds = async () => {
	const results = await axios.get(
		"/AssetManagement/DewarProductTypeIds",
	).catch(handleRequestError);

	return results.data;
};

export const getCachedSerialNumbers = memoizePromiseFn(getDewarContainerSerialNumbers);
export const getCachedProductTypeIds = memoizePromiseFn(getDewarProductTypeIds);